var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-container" }, [
    _vm.showNavbar
      ? _c(
          "div",
          { staticClass: "nav-container" },
          [
            _vm.isHomePage
              ? _c("van-nav-bar", {
                  attrs: { title: "", border: false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _c("img", {
                              staticClass: "logo",
                              attrs: { src: _vm.logo }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#fff",
                                  "padding-left": "0.3rem"
                                }
                              },
                              [_vm._v(_vm._s(_vm.title))]
                            )
                          ]
                        },
                        proxy: true
                      },
                      _vm.showLogout
                        ? {
                            key: "right",
                            fn: function() {
                              return [
                                _vm.isWeChatBrowser
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "logout",
                                        on: { click: _vm.listAccount }
                                      },
                                      [_vm._v("账户")]
                                    )
                                  : _vm._e(),
                                !_vm.isWeChatBrowser
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "logout",
                                        on: { click: _vm.logout }
                                      },
                                      [_vm._v("登出")]
                                    )
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                })
              : _vm.noBack
              ? _c("van-nav-bar", {
                  attrs: {
                    title: _vm.title,
                    "left-text": "返回",
                    "left-arrow": "",
                    border: false
                  },
                  on: { "click-left": _vm.goBack },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _c("van-icon", {
                              attrs: { name: "wap-home-o" },
                              on: { click: _vm.goHome }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2106746360
                  )
                })
              : _c("van-nav-bar", {
                  attrs: { title: _vm.title, border: false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [_c("img", { attrs: { src: _vm.logo } })]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _c("van-icon", {
                              attrs: { name: "wap-home-o" },
                              on: { click: _vm.goHome }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2781619012
                  )
                })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { class: _vm.layoutClass },
      [
        _c(
          "keep-alive",
          { attrs: { exclude: _vm.exclude } },
          [_c("router-view", { key: _vm.pathKey })],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }